export var DATE_RANGE_FROM_ACROSS_TABS_KEY = 'date-range-from-shared-across-tabs';
export var DATE_RANGE_TO_ACROSS_TABS_KEY = 'date-range-to-shared-across-tabs';
